import { EndpointsName } from './../../Auth/authTypes';
import { catchError } from "rxjs/operators";
import { get } from "../../Auth";
import { ConfigLImits, ProcessType } from "../../types";

export const getLimitsData = (process: ProcessType) =>
    get<ConfigLImits>(EndpointsName.LIMITS, `/${process}`).pipe(
        catchError((err) => { throw err })
    );